import { Logo } from "./Logo";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { label: "The Offer", id: "#offer" },
  { label: "How It Works", id: "#how-it-works" },
  { label: "Monthly", id: "#monthly" },
  { label: "FAQ", id: "#faq" },
];

export const Header = () => (
  <header
    data-testid="site-header"
    className="fixed inset-x-0 top-0 z-50 border-b border-black/5 bg-cream/80 backdrop-blur-xl"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 sm:px-8 lg:px-12">
      <button
        data-testid="header-logo-button"
        onClick={() => window.scrollTo({ top: 0 })}
        aria-label="LocalLift — back to top"
        className="transition-transform duration-300 hover:scale-[1.03]"
      >
        <Logo />
      </button>
      <nav className="hidden items-center gap-8 md:flex" aria-label="Primary">
        {LINKS.map((l) => (
          <button
            key={l.id}
            data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            onClick={() => scrollToId(l.id)}
            className="font-heading text-sm font-bold text-soot transition-colors duration-300 hover:text-pine"
          >
            {l.label}
          </button>
        ))}
      </nav>
      <button
        data-testid="header-cta-button"
        onClick={() => scrollToId("#audit-form")}
        className="btn-primary hidden !px-6 !py-2.5 text-sm md:inline-flex"
      >
        Get My Free Audit
      </button>
    </div>
  </header>
);
